import { api, endpoints } from "api/api";
import { BaseApiPaging } from "api/types";
import { AxiosPromise } from "axios";

const fetch = (
  skip: number,
  take: number,
  searchPhrase: string,
  filter: string = "",
  orderBy: string = ""
): AxiosPromise<BaseApiPaging<DocumentTypeApi>> => {
  return api.get<BaseApiPaging<DocumentTypeApi>>(
    endpoints.DOCUMENT_TYPES.GET(skip, take, searchPhrase, filter, orderBy)
  );
};

const fetchById = (documentTypeId: number): AxiosPromise<DocumentTypeApi> => {
  return api.get<DocumentTypeApi>(endpoints.DOCUMENT_TYPES.GET_BY_ID(documentTypeId));
};

const update = (documentTypeId: number, body: DocumentTypeModel): AxiosPromise => {
  return api.put(endpoints.DOCUMENT_TYPES.UPDATE(documentTypeId), body);
};

const create = (body: DocumentTypeModel): AxiosPromise => {
  return api.post(endpoints.DOCUMENT_TYPES.CREATE(), body);
};

const deleteDocumentType = (documentTypeId: number): Promise<void> => {
  return api.delete(endpoints.DOCUMENT_TYPES.DELETE(documentTypeId));
};

export const documentTypesApi = {
  fetch,
  fetchById,
  create,
  update,
  delete: deleteDocumentType,
};

export interface DocumentTypeApi {
  id: number;
  name: string;
  validity: number;
  /** The number the next 2.0 document of this type gets. */
  nextNumber: number;
}

export interface DocumentTypeModel {
  name: string;
  validity: number;
  /** The number the next 2.0 document gets (integer >= 1). Omitted or null leaves it unchanged (default 1 on create). */
  nextNumber?: number | null;
}
